const coverageStatementExistenceStatuses = {
  YES: 'yes',
  NO: 'no',
};

export default coverageStatementExistenceStatuses;
